/**
 * Authentication Progress Overlay
 * Shows a full-screen overlay with loading spinner during sign in and sign out
 */
import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { LoadingSpinner } from '../Loading/LoadingSpinner';
import './AuthProgressOverlay.css';

export const AuthProgressOverlay: React.FC = () => {
  const { isLoggingIn, isLoggingOut } = useAuth();

  // Don't render if neither logging in nor logging out
  if (!isLoggingIn && !isLoggingOut) {
    return null;
  }

  const message = isLoggingOut ? 'Signing out...' : 'Signing in...';

  return (
    <div 
      className="auth-progress-overlay"
      role="status"
      aria-live="polite"
      aria-label={message}
    >
      <div className="auth-progress-overlay-content">
        <LoadingSpinner layout="embedded" message={message} ariaLabel={message} />
      </div>
    </div>
  );
};

